import React from 'react';
import RecallSettings from './RecallSettings';
import RecallTimings from './RecallTimings';

function RecallsTab() {
    return (
        <div className="d-flex flex-column gap-3">
            <RecallSettings />
            <RecallTimings />
        </div>
    );
}

export default RecallsTab;
